export default "__VITE_ASSET__DsJK$SqZ__"